import { render } from "./UITable.vue?vue&type=template&id=9d193eec&scoped=true&ts=true"
import script from "./UITable.vue?vue&type=script&lang=ts"
export * from "./UITable.vue?vue&type=script&lang=ts"

import "./UITable.vue?vue&type=style&index=0&id=9d193eec&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d193eec"]])

export default __exports__